export default __webpack_public_path__ + "static/Inter-Bold-ae7a4e132b9d5c002e376c5ab195003c.woff";